import React from 'react';
import { GradientStarIcon } from 'icons';
import { useTranslations } from 'next-intl';

import { HomeScreenFAQ } from 'modules/home';

import Features from './features';
import { Feedbacks } from './feedbacks';
import { PaymentPlanSelector } from './payment-plan-selector';
import { SocialMedias } from './social-medias';
import Statistics from './statistics';

const Main = () => {
  const t = useTranslations();

  return (
    <>
      <div className="max-w-screen mx-auto px-0 sm:px-4 md:px-0">
        <div className="from-green-450 to-blue-450 mt-13 mb-6 flex items-center text-center justify-center gap-2.5 bg-gradient-to-br bg-clip-text text-xl md:text-3xl font-bold text-transparent">
          <div className="hidden md:block">
            <GradientStarIcon />
          </div>
          <h1>
            Akam Premium
            <span className="text-xl md:text-2xl text-gray-800"> - {t('cheksiz_testlar_sizni_kutmoqda')}</span>
          </h1>
        </div>
        <div className="grid grid-cols-1 gap-4 sm:px-10 px-0.5 md:px-30 lg:px-0 lg:grid-cols-2">
          <Statistics />
          <PaymentPlanSelector />
        </div>
        <Features />
      </div>
      <Feedbacks />
      <div className="max-w-screen mx-auto">
        <SocialMedias />
      </div>
      <div className="mx-auto max-w-[54rem]">
        <HomeScreenFAQ />
      </div>
    </>
  );
};

export default Main;
